import { Node, Edge } from 'reactflow';
import { useTranslation } from 'react-i18next';
import { CardNodeData } from 'store/ducks/Global/types';

const lineStyle = {
  strokeWidth: 2,
};

export const useTreeFlowData = () => {
  const { t } = useTranslation();

  const nodes: Node<CardNodeData>[] = [
    {
      id: 'registry',
      type: 'cardNode',
      position: { x: 0, y: 0 },
      data: {
        title: t('AREAS.ENTITY_MAINTAINING_REGISTER_OF_INFORMATION'),
        href: '/data_entry/entity_maintaining_registry',
      },
    },
    {
      id: 'entity',
      type: 'cardNode',
      position: { x: 250, y: 0 },
      data: {
        title: t('AREAS.ENTITY'),
        href: '/data_entry/entity',
      },
    },
    {
      id: 'branch',
      type: 'cardNode',
      position: { x: 500, y: 0 },
      data: {
        title: t('AREAS.BRANCH'),
        href: '/data_entry/branch',
      },
    },
    {
      id: 'function',
      type: 'cardNode',
      position: { x: 250, y: 140 },
      data: {
        title: t('AREAS.FUNCTION'),
        href: '/data_entry/function',
      },
    },
    {
      id: 'third_party',
      type: 'cardNode',
      position: { x: 250, y: 280 },
      data: {
        title: t('AREAS.ICT_THIRD_PARTY_SERVICE_PROVIDER'),
        href: '/data_entry/third_party_provider',
      },
    },
    {
      id: 'contract',
      type: 'cardNode',
      position: { x: 250, y: 420 },
      data: {
        title: t('AREAS.CONTRACTUAL_INFORMATION'),
        href: '/data_entry/contractual_information',
      },
    },
    {
      id: 'systems',
      type: 'cardNode',
      position: { x: 500, y: 140 },
      data: {
        title: t('AREAS.ICT_SYSTEMS'),
        href: '/data_management/ict_systems',
      },
    },
    {
      id: 'details',
      type: 'cardNode',
      position: { x: 750, y: 140 },
      data: {
        title: t('AREAS.DATA'),
        href: '/data_management/data',
      },
    },
    {
      id: 'service',
      type: 'cardNode',
      position: { x: 500, y: 420 },
      data: {
        title: t('AREAS.ICT_SERVICE'),
        href: '/data_entry/ict_service',
      },
    },
  ];

  const edges: Edge[] = [
    {
      id: 'e1',
      source: 'registry',
      target: 'entity',
      type: 'straight',
      style: lineStyle,
      sourceHandle: 'right',
      targetHandle: 'left',
    },
    {
      id: 'e2',
      source: 'entity',
      target: 'branch',
      type: 'straight',
      style: lineStyle,
      sourceHandle: 'right',
      targetHandle: 'left',
    },
    {
      id: 'e3',
      source: 'entity',
      target: 'function',
      type: 'straight',
      style: lineStyle,
      sourceHandle: 'bottom',
      targetHandle: 'top',
    },
    {
      id: 'e4',
      source: 'function',
      target: 'third_party',
      type: 'straight',
      style: lineStyle,
      sourceHandle: 'bottom',
      targetHandle: 'top',
    },
    {
      id: 'e5',
      source: 'third_party',
      target: 'contract',
      type: 'straight',
      style: lineStyle,
      sourceHandle: 'bottom',
      targetHandle: 'top',
    },
    {
      id: 'e6',
      source: 'contract',
      target: 'service',
      type: 'straight',
      style: lineStyle,
      sourceHandle: 'right',
      targetHandle: 'left',
    },
    {
      id: 'e7',
      source: 'function',
      target: 'systems',
      type: 'straight',
      style: lineStyle,
      sourceHandle: 'right',
      targetHandle: 'left',
    },
    {
      id: 'e8',
      source: 'systems',
      target: 'details',
      type: 'straight',
      style: lineStyle,
      sourceHandle: 'right',
      targetHandle: 'left',
    },
  ];

  return { nodes, edges };
};
